import { Attachment, AttachmentType } from 'types/AmplifiedTemplate';

// Single source of truth for whether an attachment has enough data to
// render a preview tile. Reused by every place that decides whether to
// mount AttachmentPreview/MediaView (LinkedInPreview, AttachmentPreview,
// SharePostCard) — previously each kept its own copy of this filter, and
// adding the Pdf type to one but not the others silently left PDF-only
// share cards blank (Copilot review, PR #6799).
export const isAttachmentPreviewable = (attachment: Attachment): boolean => {
  const { type, url, thumbnail_url } = attachment;
  if (type === AttachmentType.Image) return !!url;
  if (type === AttachmentType.Video) return !!(url || thumbnail_url);
  if (type === AttachmentType.Pdf) return !!url;
  // URL type (or unknown): only previewable when there is a thumbnail
  return !!thumbnail_url;
};
